<template>
  <div class="news">
    <div class="container">
      <div class="row align-items-center justify-content-between">
        <div class="col-xl-5 col-md-6 col-12">
          <div class="news__title">
            <h2>
              Quer receber <b>novidades de empreendimentos</b> e ficar ligado em tudo que acontece aqui?
            </h2>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <form @submit.prevent="submitForm">
            <input type="text" class="ui-input" v-model="form.name" name="nome" placeholder="Nome completo" required>
            <input type="email" class="ui-input email" v-model="form.email" name="email" placeholder="E-mail" required>
            <button type="submit" class="send" :disabled="disabled">
              <img :src="submitImage" alt="Enviar">
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import swal from 'sweetalert2'
export default {
  data () {
    return {
      update: false,
      submitImage: require('../assets/img/submit_green.png'),
      disabled: false,
      form: {
        name: '',
        email: ''
      }
    }
  },
  computed: {
    ...mapGetters(['contactSend'])
  },
  methods: {
    submitForm () {
      this.disabled = true
      this.submitImage = require('../assets/img/loading.gif')
      let content = {
        'destiny': 'faleconosco.comcasa@gmail.com',
        'originName': 'Website Comcasa',
        'title': 'Interesse em receber novidades',
        'message': `Uma pessoa tem interesse em receber novidades da Comcasa:<br><br>Nome: ${this.form.name}<br>E-mail: ${this.form.email}`
      }
      this.$store.dispatch('sendContactForm', {data: content})
        .then(() => {
          this.$store.dispatch('sendActiveCampaign', {data: this.form})
          swal(
            'Sucesso :)',
            'Seu cadastro foi realizado em nosso newsletter.',
            'success'
          )
          this.form = {
            name: '',
            email: ''
          }
          this.submitImage = require('../assets/img/submit_green.png')
          this.disabled = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';
.news {
  padding: 80px 0;
  background: $silver;
  &__title {
    position: relative;
    z-index: 10;
    h2 {
      color: white;
      font-size: 28px;
      font-weight: 300;
      line-height: 48px;
      b{
        font-weight: bold;
      }
    }
    &:before {
      color: #2c2e33;
      content: 'NOVI
      DADES';
      font-size: 130px;
      font-weight: 900;
      left: -100px;
      line-height: 135px;
      position: absolute;
      top: -60px;
      z-index: -1;
    }
  }
  .email {
    position: relative;
  }
  form {
    margin-top: 20px;
  }
  .send {
    border: none;
    background: none;
    cursor: pointer;
    outline: none;
    position: absolute;
    right: 16px;
    bottom: 24px;
    &:focus {
      outline: none;
    }

    img{
      border-radius: 50px;
    }
  }
  @media (max-width: 1200px) {
    &__title {
     h2 {
      font-size: 26px;
      line-height: 40px;
     }
      &:before {
        font-size: 100px;
        left: -20px;
        top: -40px;
        line-height: 105px;
      }
    }
  }
  @media (max-width: 991px) {
    padding: 60px 0;
    &__title {
      &:before {
        font-size: 80px;
        left: -20px;
        top: -30px;
        line-height: 105px;
      }
    }
  }
  @media (max-width: 767px) {
    padding: 40px 0;
    &__title {
      margin-bottom: 10px;
      h2 {
        font-size: 22px;
        line-height: 32px;
      }
      &:before {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewsFooter.vue